"use strict";
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD = "add";
exports.ADD_COLUMN_LEFT = "add-column-left";
exports.ADD_COLUMN_RIGHT = "add-column-right";
exports.ADD_ROW_BOTTOM = "add-row-bottom";
exports.ADD_ROW_TOP = "add-row-top";
exports.ADD_TO_ARTIFACT = "add-to-artifact";
exports.ADD_TO_FOLDER = "add-to-folder";
exports.AIRPLANE = "airplane";
exports.ALIGN_CENTER = "align-center";
exports.ALIGN_JUSTIFY = "align-justify";
exports.ALIGN_LEFT = "align-left";
exports.ALIGN_RIGHT = "align-right";
exports.ALIGNMENT_BOTTOM = "alignment-bottom";
exports.ALIGNMENT_HORIZONTAL_CENTER = "alignment-horizontal-center";
exports.ALIGNMENT_LEFT = "alignment-left";
exports.ALIGNMENT_RIGHT = "alignment-right";
exports.ALIGNMENT_TOP = "alignment-top";
exports.ALIGNMENT_VERTICAL_CENTER = "alignment-vertical-center";
exports.ANNOTATION = "annotation";
exports.APPLICATION = "application";
exports.APPLICATIONS = "applications";
exports.ARROW_BOTTOM_LEFT = "arrow-bottom-left";
exports.ARROW_BOTTOM_RIGHT = "arrow-bottom-right";
exports.ARROW_DOWN = "arrow-down";
exports.ARROW_LEFT = "arrow-left";
exports.ARROW_RIGHT = "arrow-right";
exports.ARROW_TOP_LEFT = "arrow-top-left";
exports.ARROW_TOP_RIGHT = "arrow-top-right";
exports.ARROW_UP = "arrow-up";
exports.ARROWS_HORIZONTAL = "arrows-horizontal";
exports.ARROWS_VERTICAL = "arrows-vertical";
exports.ASTERISK = "asterisk";
exports.AUTOMATIC_UPDATES = "automatic-updates";
exports.BADGE = "badge";
exports.BAN_CIRCLE = "ban-circle";
exports.BANK_ACCOUNT = "bank-account";
exports.BARCODE = "barcode";
exports.BLANK = "blank";
exports.BLOCKED_PERSON = "blocked-person";
exports.BOLD = "bold";
exports.BOOK = "book";
exports.BOOKMARK = "bookmark";
exports.BOX = "box";
exports.BRIEFCASE = "briefcase";
exports.BUILD = "build";
exports.CALCULATOR = "calculator";
exports.CALENDAR = "calendar";
exports.CAMERA = "camera";
exports.CARET_DOWN = "caret-down";
exports.CARET_LEFT = "caret-left";
exports.CARET_RIGHT = "caret-right";
exports.CARET_UP = "caret-up";
exports.CELL_TOWER = "cell-tower";
exports.CHANGES = "changes";
exports.CHART = "chart";
exports.CHAT = "chat";
exports.CHEVRON_BACKWARD = "chevron-backward";
exports.CHEVRON_DOWN = "chevron-down";
exports.CHEVRON_FORWARD = "chevron-forward";
exports.CHEVRON_LEFT = "chevron-left";
exports.CHEVRON_RIGHT = "chevron-right";
exports.CHEVRON_UP = "chevron-up";
exports.CIRCLE = "circle";
exports.CIRCLE_ARROW_DOWN = "circle-arrow-down";
exports.CIRCLE_ARROW_LEFT = "circle-arrow-left";
exports.CIRCLE_ARROW_RIGHT = "circle-arrow-right";
exports.CIRCLE_ARROW_UP = "circle-arrow-up";
exports.CITATION = "citation";
exports.CLEAN = "clean";
exports.CLIPBOARD = "clipboard";
exports.CLOUD = "cloud";
exports.CLOUD_DOWNLOAD = "cloud-download";
exports.CLOUD_UPLOAD = "cloud-upload";
exports.CODE = "code";
exports.CODE_BLOCK = "code-block";
exports.COG = "cog";
exports.COLLAPSE_ALL = "collapse-all";
exports.COLUMN_LAYOUT = "column-layout";
exports.COMMENT = "comment";
exports.COMPARISON = "comparison";
exports.COMPASS = "compass";
exports.COMPRESSED = "compressed";
exports.CONFIRM = "confirm";
exports.CONSOLE = "console";
exports.CONTRAST = "contrast";
exports.CONTROL = "control";
exports.CREDIT_CARD = "credit-card";
exports.CROSS = "cross";
exports.CROWN = "crown";
exports.CUBE = "cube";
exports.CUBE_ADD = "cube-add";
exports.CUBE_REMOVE = "cube-remove";
exports.CURVED_RANGE_CHART = "curved-range-chart";
exports.CUT = "cut";
exports.DASHBOARD = "dashboard";
exports.DATABASE = "database";
exports.DELETE = "delete";
exports.DELTA = "delta";
exports.DERIVE_COLUMN = "derive-column";
exports.DESKTOP = "desktop";
exports.DIAGRAM_TREE = "diagram-tree";
exports.DIRECTION_LEFT = "direction-left";
exports.DIRECTION_RIGHT = "direction-right";
exports.DISABLE = "disable";
exports.DOCUMENT = "document";
exports.DOCUMENT_OPEN = "document-open";
exports.DOCUMENT_SHARE = "document-share";
exports.DOLLAR = "dollar";
exports.DOT = "dot";
exports.DOUBLE_CARET_HORIZONTAL = "double-caret-horizontal";
exports.DOUBLE_CARET_VERTICAL = "double-caret-vertical";
exports.DOUBLE_CHEVRON_DOWN = "double-chevron-down";
exports.DOUBLE_CHEVRON_LEFT = "double-chevron-left";
exports.DOUBLE_CHEVRON_RIGHT = "double-chevron-right";
exports.DOUBLE_CHEVRON_UP = "double-chevron-up";
exports.DOUGHNUT_CHART = "doughnut-chart";
exports.DOWNLOAD = "download";
exports.DRAG_HANDLE_HORIZONTAL = "drag-handle-horizontal";
exports.DRAG_HANDLE_VERTICAL = "drag-handle-vertical";
exports.DRAW = "draw";
exports.DRIVE_TIME = "drive-time";
exports.DUPLICATE = "duplicate";
exports.EDIT = "edit";
exports.EJECT = "eject";
exports.ENDORSED = "endorsed";
exports.ENVELOPE = "envelope";
exports.ERASER = "eraser";
exports.ERROR = "error";
exports.EURO = "euro";
exports.EXCHANGE = "exchange";
exports.EXCLUDE_ROW = "exclude-row";
exports.EXPAND_ALL = "expand-all";
exports.EXPORT = "export";
exports.EYE_OFF = "eye-off";
exports.EYE_ON = "eye-on";
exports.EYE_OPEN = "eye-open";
exports.FAST_BACKWARD = "fast-backward";
exports.FAST_FORWARD = "fast-forward";
exports.FEED = "feed";
exports.FEED_SUBSCRIBED = "feed-subscribed";
exports.FILM = "film";
exports.FILTER = "filter";
exports.FILTER_KEEP = "filter-keep";
exports.FILTER_LIST = "filter-list";
exports.FILTER_REMOVE = "filter-remove";
exports.FLAG = "flag";
exports.FLAME = "flame";
exports.FLASH = "flash";
exports.FLOPPY_DISK = "floppy-disk";
exports.FLOW_BRANCH = "flow-branch";
exports.FLOW_END = "flow-end";
exports.FLOW_LINEAR = "flow-linear";
exports.FLOW_REVIEW = "flow-review";
exports.FLOW_REVIEW_BRANCH = "flow-review-branch";
exports.FLOWS = "flows";
exports.FOLDER_CLOSE = "folder-close";
exports.FOLDER_NEW = "folder-new";
exports.FOLDER_OPEN = "folder-open";
exports.FOLDER_SHARED = "folder-shared";
exports.FOLDER_SHARED_OPEN = "folder-shared-open";
exports.FOLLOWER = "follower";
exports.FOLLOWING = "following";
exports.FONT = "font";
exports.FORK = "fork";
exports.FORM = "form";
exports.FULL_CIRCLE = "full-circle";
exports.FULL_STACKED_CHART = "full-stacked-chart";
exports.FULLSCREEN = "fullscreen";
exports.FUNCTION = "function";
exports.GANTT_CHART = "gantt-chart";
exports.GEOLOCATION = "geolocation";
exports.GEOSEARCH = "geosearch";
exports.GIT_BRANCH = "git-branch";
exports.GIT_COMMIT = "git-commit";
exports.GIT_MERGE = "git-merge";
exports.GIT_NEW_BRANCH = "git-new-branch";
exports.GIT_PULL = "git-pull";
exports.GIT_PUSH = "git-push";
exports.GIT_REPO = "git-repo";
exports.GLASS = "glass";
exports.GLOBE = "globe";
exports.GLOBE_NETWORK = "globe-network";
exports.GRAPH = "graph";
exports.GRAPH_REMOVE = "graph-remove";
exports.GRID = "grid";
exports.GRID_VIEW = "grid-view";
exports.GROUP_OBJECTS = "group-objects";
exports.GROUPED_BAR_CHART = "grouped-bar-chart";
exports.HAND = "hand";
exports.HAND_DOWN = "hand-down";
exports.HAND_LEFT = "hand-left";
exports.HAND_RIGHT = "hand-right";
exports.HAND_UP = "hand-up";
exports.HEADER = "header";
exports.HEADER_ONE = "header-one";
exports.HEADER_TWO = "header-two";
exports.HEADSET = "headset";
exports.HEART = "heart";
exports.HEART_BROKEN = "heart-broken";
exports.HEAT_GRID = "heat-grid";
exports.HEATMAP = "heatmap";
exports.HELP = "help";
exports.HELPER_MANAGEMENT = "helper-management";
exports.HIGHLIGHT = "highlight";
exports.HISTORY = "history";
exports.HOME = "home";
exports.HORIZONTAL_BAR_CHART = "horizontal-bar-chart";
exports.HORIZONTAL_BAR_CHART_ASC = "horizontal-bar-chart-asc";
exports.HORIZONTAL_BAR_CHART_DESC = "horizontal-bar-chart-desc";
exports.HORIZONTAL_DISTRIBUTION = "horizontal-distribution";
exports.ID_NUMBER = "id-number";
exports.IMAGE_ROTATE_LEFT = "image-rotate-left";
exports.IMAGE_ROTATE_RIGHT = "image-rotate-right";
exports.IMPORT = "import";
exports.INBOX = "inbox";
exports.INBOX_FILTERED = "inbox-filtered";
exports.INBOX_GEO = "inbox-geo";
exports.INBOX_SEARCH = "inbox-search";
exports.INBOX_UPDATE = "inbox-update";
exports.INFO_SIGN = "info-sign";
exports.INHERITANCE = "inheritance";
exports.INNER_JOIN = "inner-join";
exports.INSERT = "insert";
exports.INTERSECTION = "intersection";
exports.IP_ADDRESS = "ip-address";
exports.ISSUE = "issue";
exports.ISSUE_CLOSED = "issue-closed";
exports.ISSUE_NEW = "issue-new";
exports.ITALIC = "italic";
exports.JOIN_TABLE = "join-table";
exports.KEY = "key";
exports.KEY_BACKSPACE = "key-backspace";
exports.KEY_COMMAND = "key-command";
exports.KEY_CONTROL = "key-control";
exports.KEY_DELETE = "key-delete";
exports.KEY_ENTER = "key-enter";
exports.KEY_ESCAPE = "key-escape";
exports.KEY_OPTION = "key-option";
exports.KEY_SHIFT = "key-shift";
exports.KEY_TAB = "key-tab";
exports.KNOWN_VEHICLE = "known-vehicle";
exports.LABEL = "label";
exports.LAYER = "layer";
exports.LAYERS = "layers";
exports.LAYOUT = "layout";
exports.LAYOUT_AUTO = "layout-auto";
exports.LAYOUT_BALLOON = "layout-balloon";
exports.LAYOUT_CIRCLE = "layout-circle";
exports.LAYOUT_GRID = "layout-grid";
exports.LAYOUT_GROUP_BY = "layout-group-by";
exports.LAYOUT_HIERARCHY = "layout-hierarchy";
exports.LAYOUT_LINEAR = "layout-linear";
exports.LAYOUT_SKEW_GRID = "layout-skew-grid";
exports.LAYOUT_SORTED_CLUSTERS = "layout-sorted-clusters";
exports.LEFT_JOIN = "left-join";
exports.LIFESAVER = "lifesaver";
exports.LIGHTBULB = "lightbulb";
exports.LINK = "link";
exports.LIST = "list";
exports.LIST_COLUMNS = "list-columns";
exports.LIST_DETAIL_VIEW = "list-detail-view";
exports.LOCATE = "locate";
exports.LOCK = "lock";
exports.LOG_IN = "log-in";
exports.LOG_OUT = "log-out";
exports.MANUAL = "manual";
exports.MANUALLY_ENTERED_DATA = "manually-entered-data";
exports.MAP = "map";
exports.MAP_CREATE = "map-create";
exports.MAP_MARKER = "map-marker";
exports.MAXIMIZE = "maximize";
exports.MEDIA = "media";
exports.MENU = "menu";
exports.MENU_CLOSED = "menu-closed";
exports.MENU_OPEN = "menu-open";
exports.MERGE_COLUMNS = "merge-columns";
exports.MERGE_LINKS = "merge-links";
exports.MINIMIZE = "minimize";
exports.MINUS = "minus";
exports.MOBILE_PHONE = "mobile-phone";
exports.MOBILE_VIDEO = "mobile-video";
exports.MOON = "moon";
exports.MORE = "more";
exports.MOUNTAIN = "mountain";
exports.MOVE = "move";
exports.MUGSHOT = "mugshot";
exports.MULTI_SELECT = "multi-select";
exports.MUSIC = "music";
exports.NEW_GRID_ITEM = "new-grid-item";
exports.NEW_LINK = "new-link";
exports.NEW_OBJECT = "new-object";
exports.NEW_PERSON = "new-person";
exports.NEW_PRESCRIPTION = "new-prescription";
exports.NEW_TEXT_BOX = "new-text-box";
exports.NINJA = "ninja";
exports.NOTIFICATIONS = "notifications";
exports.NOTIFICATIONS_UPDATED = "notifications-updated";
exports.NUMBERED_LIST = "numbered-list";
exports.NUMERICAL = "numerical";
exports.OFFICE = "office";
exports.OFFLINE = "offline";
exports.OIL_FIELD = "oil-field";
exports.ONE_COLUMN = "one-column";
exports.OUTDATED = "outdated";
exports.PAGE_LAYOUT = "page-layout";
exports.PANEL_STATS = "panel-stats";
exports.PANEL_TABLE = "panel-table";
exports.PAPERCLIP = "paperclip";
exports.PARAGRAPH = "paragraph";
exports.PATH = "path";
exports.PATH_SEARCH = "path-search";
exports.PAUSE = "pause";
exports.PEOPLE = "people";
exports.PERCENTAGE = "percentage";
exports.PERSON = "person";
exports.PHONE = "phone";
exports.PIE_CHART = "pie-chart";
exports.PIN = "pin";
exports.PIVOT = "pivot";
exports.PIVOT_TABLE = "pivot-table";
exports.PLAY = "play";
exports.PLUS = "plus";
exports.POLYGON_FILTER = "polygon-filter";
exports.POWER = "power";
exports.PREDICTIVE_ANALYSIS = "predictive-analysis";
exports.PRESCRIPTION = "prescription";
exports.PRESENTATION = "presentation";
exports.PRINT = "print";
exports.PROJECTS = "projects";
exports.PROPERTIES = "properties";
exports.PROPERTY = "property";
exports.PUBLISH_FUNCTION = "publish-function";
exports.PULSE = "pulse";
exports.RANDOM = "random";
exports.RECORD = "record";
exports.REDO = "redo";
exports.REFRESH = "refresh";
exports.REGRESSION_CHART = "regression-chart";
exports.REMOVE = "remove";
exports.REMOVE_COLUMN = "remove-column";
exports.REMOVE_COLUMN_LEFT = "remove-column-left";
exports.REMOVE_COLUMN_RIGHT = "remove-column-right";
exports.REMOVE_ROW_BOTTOM = "remove-row-bottom";
exports.REMOVE_ROW_TOP = "remove-row-top";
exports.REPEAT = "repeat";
exports.RESOLVE = "resolve";
exports.RIG = "rig";
exports.RIGHT_JOIN = "right-join";
exports.RING = "ring";
exports.ROTATE_DOCUMENT = "rotate-document";
exports.ROTATE_PAGE = "rotate-page";
exports.SATELLITE = "satellite";
exports.SAVED = "saved";
exports.SCATTER_PLOT = "scatter-plot";
exports.SEARCH = "search";
exports.SEARCH_AROUND = "search-around";
exports.SEARCH_TEMPLATE = "search-template";
exports.SEARCH_TEXT = "search-text";
exports.SEGMENTED_CONTROL = "segmented-control";
exports.SELECT = "select";
exports.SELECTION = "selection";
exports.SEND_TO = "send-to";
exports.SEND_TO_GRAPH = "send-to-graph";
exports.SEND_TO_MAP = "send-to-map";
exports.SERIES_ADD = "series-add";
exports.SERIES_CONFIGURATION = "series-configuration";
exports.SERIES_DERIVED = "series-derived";
exports.SERIES_FILTERED = "series-filtered";
exports.SERIES_SEARCH = "series-search";
exports.SETTINGS = "settings";
exports.SHARE = "share";
exports.SHIELD = "shield";
exports.SHOP = "shop";
exports.SHOPPING_CART = "shopping-cart";
exports.SIM_CARD = "sim-card";
exports.SLASH = "slash";
exports.SMALL_CROSS = "small-cross";
exports.SMALL_MINUS = "small-minus";
exports.SMALL_PLUS = "small-plus";
exports.SMALL_TICK = "small-tick";
exports.SNOWFLAKE = "snowflake";
exports.SOCIAL_MEDIA = "social-media";
exports.SORT = "sort";
exports.SORT_ALPHABETICAL = "sort-alphabetical";
exports.SORT_ALPHABETICAL_DESC = "sort-alphabetical-desc";
exports.SORT_ASC = "sort-asc";
exports.SORT_DESC = "sort-desc";
exports.SORT_NUMERICAL = "sort-numerical";
exports.SORT_NUMERICAL_DESC = "sort-numerical-desc";
exports.SPLIT_COLUMNS = "split-columns";
exports.SQUARE = "square";
exports.STACKED_CHART = "stacked-chart";
exports.STAR = "star";
exports.STAR_EMPTY = "star-empty";
exports.STEP_BACKWARD = "step-backward";
exports.STEP_CHART = "step-chart";
exports.STEP_FORWARD = "step-forward";
exports.STOP = "stop";
exports.STRIKETHROUGH = "strikethrough";
exports.STYLE = "style";
exports.SWAP_HORIZONTAL = "swap-horizontal";
exports.SWAP_VERTICAL = "swap-vertical";
exports.SYMBOL_CIRCLE = "symbol-circle";
exports.SYMBOL_CROSS = "symbol-cross";
exports.SYMBOL_DIAMOND = "symbol-diamond";
exports.SYMBOL_SQUARE = "symbol-square";
exports.SYMBOL_TRIANGLE_DOWN = "symbol-triangle-down";
exports.SYMBOL_TRIANGLE_UP = "symbol-triangle-up";
exports.TAG = "tag";
exports.TAKE_ACTION = "take-action";
exports.TAXI = "taxi";
exports.TEXT_HIGHLIGHT = "text-highlight";
exports.TH = "th";
exports.TH_DERIVED = "th-derived";
exports.TH_FILTERED = "th-filtered";
exports.TH_LIST = "th-list";
exports.THUMBS_DOWN = "thumbs-down";
exports.THUMBS_UP = "thumbs-up";
exports.TICK = "tick";
exports.TICK_CIRCLE = "tick-circle";
exports.TIME = "time";
exports.TIMELINE_AREA_CHART = "timeline-area-chart";
exports.TIMELINE_BAR_CHART = "timeline-bar-chart";
exports.TIMELINE_EVENTS = "timeline-events";
exports.TIMELINE_LINE_CHART = "timeline-line-chart";
exports.TINT = "tint";
exports.TORCH = "torch";
exports.TRAIN = "train";
exports.TRANSLATE = "translate";
exports.TRASH = "trash";
exports.TREE = "tree";
exports.TRENDING_DOWN = "trending-down";
exports.TRENDING_UP = "trending-up";
exports.TWO_COLUMNS = "two-columns";
exports.UNDERLINE = "underline";
exports.UNDO = "undo";
exports.UNGROUP_OBJECTS = "ungroup-objects";
exports.UNKNOWN_VEHICLE = "unknown-vehicle";
exports.UNLOCK = "unlock";
exports.UNPIN = "unpin";
exports.UNRESOLVE = "unresolve";
exports.UPDATED = "updated";
exports.UPLOAD = "upload";
exports.USER = "user";
exports.VARIABLE = "variable";
exports.VERTICAL_BAR_CHART_ASC = "vertical-bar-chart-asc";
exports.VERTICAL_BAR_CHART_DESC = "vertical-bar-chart-desc";
exports.VERTICAL_DISTRIBUTION = "vertical-distribution";
exports.VIDEO = "video";
exports.VOLUME_DOWN = "volume-down";
exports.VOLUME_OFF = "volume-off";
exports.VOLUME_UP = "volume-up";
exports.WALK = "walk";
exports.WARNING_SIGN = "warning-sign";
exports.WATERFALL_CHART = "waterfall-chart";
exports.WIDGET = "widget";
exports.WIDGET_BUTTON = "widget-button";
exports.WIDGET_FOOTER = "widget-footer";
exports.WIDGET_HEADER = "widget-header";
exports.WRENCH = "wrench";
exports.ZOOM_IN = "zoom-in";
exports.ZOOM_OUT = "zoom-out";
exports.ZOOM_TO_FIT = "zoom-to-fit";
//# sourceMappingURL=iconNames.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@blueprintjs/icons/lib/cjs/generated/iconNames.js
// module id = 128
// module chunks = 0